import { Component, Input, OnInit } from '@angular/core';
import { ProductChangeNoticeSection } from 'src/app/model/section/product-change-notice-section';

@Component({
  selector: 'app-revision-notices-product-change-notice-section',
  templateUrl: './revision-notices-product-change-notice-section.component.html',
  styleUrls: ['./revision-notices-product-change-notice-section.component.scss']
})
export class RevisionNoticesProductChangeNoticeSectionComponent implements OnInit {
  @Input() productChangeNoticeSections: ProductChangeNoticeSection[] = [];
  constructor() {}

  ngOnInit(): void {}
}
